import React from 'react';

interface HeroBackgroundProps {
  /** 'full' = 100vh (homepage), 'third' = 33vh (other pages) */
  size?: 'full' | 'third';
  imageSrc?: string;
  /**
   * Start of the crop on the source image as a percent from the top (0 = top).
   * Example: 10 => start crop at 10% from the top of the original image.
   */
  startPercent?: number;
  /**
   * Portion of the original image (in percent) to display vertically.
   * Default 33 => show 33% slice of the original image.
   */
  visiblePercent?: number;
}

export const HeroBackground: React.FC<HeroBackgroundProps> = ({
  size = 'full',
  imageSrc = '/11novembre2023.jpg',
  startPercent = 15,
  visiblePercent = 33,
}) => {
  const heightClass = size === 'full' ? 'h-screen' : 'h-[44vh]';

  // Compute focal point: object-position expects the focal center.
  // If you want the visible slice to start at startPercent and have height visiblePercent,
  // the center of that slice is startPercent + visiblePercent/2.
  const centerPercent = Math.max(0, Math.min(100, startPercent + visiblePercent / 2));
  const objectPosition = size === 'third' ? `center ${centerPercent}%` : 'center';

  return (
    <div className={`fixed top-0 left-0 right-0 ${heightClass} overflow-hidden -z-10 pointer-events-none`}>
      {/* Background image - extends behind navbar and all content */}
      <div className='absolute inset-0'>
        <img
          src={imageSrc}
          alt='Minihi Levenez Community'
          className='w-full h-full object-cover'
          style={{ objectPosition }}
        />
        <div className='absolute inset-0 bg-black bg-opacity-50' />
      </div>
    </div>
  );
};
